import {
  createNewsletter,
  getNewsletters,
  deleteNewsletter,
  sendEmails,
} from "./asyncThunks";

export const createNewsletterBuilder = (builder) => {
  builder.addCase(createNewsletter.pending, (state) => {
    state.loading = true;
  });
  builder.addCase(createNewsletter.fulfilled, (state) => {
    state.loading = false;
  });
  builder.addCase(createNewsletter.rejected, (state) => {
    state.loading = false;
  });
};

export const getNewslettersBuilder = (builder) => {
  builder.addCase(getNewsletters.pending, (state) => {
    state.newsletters.loading = true;
    state.newsletters.error = null;
  });
  builder.addCase(getNewsletters.fulfilled, (state, { payload }) => {
    const { data, pagination } = payload;
    state.newsletters.data = data;
    state.newsletters.pagination = pagination;
    state.newsletters.loading = false;
  });
  builder.addCase(getNewsletters.rejected, (state, action) => {
    state.newsletters.loading = false;
    state.newsletters.error = action.error.message;
  });
};

export const deleteNewsletterBuilder = (builder) => {
  builder.addCase(deleteNewsletter.pending, (state) => {
    state.newsletters.deleteLoading = true;
    state.newsletters.error = null;
  });
  builder.addCase(deleteNewsletter.fulfilled, (state, { payload }) => {
    const { data } = payload;
    // Ukloni newsletter iz liste
    state.newsletters.data = state.newsletters.data.filter(
      (newsletter) => newsletter.id !== data.id
    );

    state.newsletters.deleteLoading = false;
  });
  builder.addCase(deleteNewsletter.rejected, (state, action) => {
    state.newsletters.deleteLoading = false;
    state.newsletters.error = action.error.message;
  });
};

export const sendEmailsBuilder = (builder) => {
  builder.addCase(sendEmails.pending, (state) => {
    state.newsletters.sendEmailsLoading = true;
    state.newsletters.error = null;
  });
  builder.addCase(sendEmails.fulfilled, (state, { payload }) => {
    state.newsletters.sendEmailsLoading = false;
    // Možete dodati email results u state ako je potrebno
    state.newsletters.lastEmailResults = payload.data;
  });
  builder.addCase(sendEmails.rejected, (state, action) => {
    state.newsletters.sendEmailsLoading = false;
    state.newsletters.error = action.error.message;
  });
};
